import { render, staticRenderFns } from "./NewPigPartModal.vue?vue&type=template&id=07d47f60"
import script from "./NewPigPartModal.vue?vue&type=script&lang=js"
export * from "./NewPigPartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports